import type { RankingResult } from '@core-api/presentation/types/response';
import type { SlidePreviewResultsInputs } from '../../types';

export const getPreviewResultsIteration = ({
  previous = [],
  iteration,
  extras: { choices },
}: SlidePreviewResultsInputs<RankingResult>): RankingResult[] => {
  if (iteration === 0 || previous.length === 0) {
    return choices.map(({ interactiveContentChoiceId }) => ({
      interactiveContentChoiceId,
      value: 0,
    }));
  }

  let totalValue = 100;
  return previous.map((result, i) => {
    const value =
      i === previous.length - 1 ? totalValue : Math.random() * totalValue;
    totalValue -= value;
    return {
      interactiveContentChoiceId: result.interactiveContentChoiceId,
      value,
    };
  });
};
